<template>
  <Modal title="轮播图广告" v-model="isShow" @on-cancel="handle">
    <div class="myModal">
        <Form ref="advertInfos"  :model='advertInfos' label-position="right" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
            <form-item label="标题" prop="advert_name">
              <Input placeholder="请输入标题" v-model="advertInfos.advert_name"></Input>
            </form-item>
            <FormItem label="图片URL">
              <div class="demo-upload-list" v-for="item in uploadList" :key="item.url" >
                <template v-if="item.status === 'finished'">
                  <img :src="item.url">
                  <div class="demo-upload-list-cover">
                    <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                    <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
                  </div>
                </template>
                <template v-else>
                  <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                </template>
              </div>
              <Upload
                v-if="uploadList.length==0"
                ref="uploadThumb"
                :show-upload-list="false"
                :on-success="handleSuccess"
                :format="['jpg','jpeg','png','gif']"
                :max-size="10240"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :before-upload="handleBeforeUpload"
                type="drag"
                :action="serverApiPic"
                style="display: inline-block;width:58px;">
                <div style="width: 58px;height:58px;line-height: 58px;">
                  <Icon type="ios-camera" size="20"></Icon>
                </div>
              </Upload>

              <Modal title="查看" v-model="visible">
                <img :src="imgUrl " v-if="visible" style="width: 100%">
              </Modal>
            </FormItem>

          <form-item label="跳转方式" prop="type">
            <RadioGroup v-model="advertInfos.type" @on-change="type_change">
              <Radio :label="0" class="radio">不跳转</Radio>
              <Radio :label="1">绘本</Radio>
              <Radio :label="2">导读</Radio>
              <Radio :label="3">活动</Radio>
              <Radio :label="4">文章</Radio>
            </RadioGroup>
          </form-item>
          <form-item :label="type_str" prop="item_id"  v-if="advertInfos.type==1">
            <Select v-model="advertInfos.item_id" style="width: 180px"   @on-change="selectChange" filterable clearable>
              <Option v-for="item in item_list1" :value="item.id" :label="item.title">
                {{ item.title }}
              </Option>
            </Select>
          </form-item>
          <form-item :label="type_str" prop="item_id"  v-if="advertInfos.type==2">
            <Select v-model="advertInfos.item_id" style="width: 180px"   @on-change="selectChange" filterable clearable>
              <Option v-for="item in item_list2" :value="item.id" :label="item.title">
                {{ item.title }}
              </Option>
            </Select>
          </form-item>
          <form-item :label="type_str" prop="item_id"  v-if="advertInfos.type ==3">
            <Select v-model="advertInfos.item_id" style="width: 180px"   @on-change="selectChange" filterable clearable>
              <Option v-for="item in item_list3" :value="item.activity_id" :label="item.title">
                {{item.title}}
              </Option>
            </Select>
          </form-item>
          <form-item :label="type_str" prop="item_id"  v-if="advertInfos.type==4">
            <Select v-model="advertInfos.item_id" style="width: 180px"   @on-change="selectChange" filterable clearable>
              <Option v-for="item in item_list4" :value="item.id" :label="item.title">
                {{ item.title }}
              </Option>
            </Select>
          </form-item>
          <form-item label="排序" prop="sort">
            <InputNumber :max="10000" :min="1" v-model="advertInfos.sort"></InputNumber>
          </form-item>
          <form-item label="状态" prop="status">
            <RadioGroup v-model="advertInfos.status">
              <Radio :label="1" class="radio">启用</Radio>
              <Radio :label="2">禁用</Radio>
            </RadioGroup>
          </form-item>
        </Form>
    </div>
    <div slot="footer">
        <Button type="primary"   @click="handleOk('advertInfos')">确定</Button>
    </div>
  </Modal>
</template>
<style scoped>
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }
   .demo-upload-list{
     display: inline-block;
     width: 60px;
     height: 60px;
     text-align: center;
     line-height: 60px;
     border: 1px solid transparent;
     border-radius: 4px;
     overflow: hidden;
     background: #fff;
     position: relative;
     box-shadow: 0 1px 1px rgba(0,0,0,.2);
     margin-right: 4px;
   }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>
<script>
import { addAdv, advertApi, bookInfo, bookVideo, activityInfo, articleInfo } from '@/api/advert'
import Setting from '@/setting'
export default {
  name: 'advertEdit',
  props: ['editShow', 'id', 'adv_group_id'],
  data () {
    return {
      selectShow: false,
      article_name: '',
      server_url: Setting.serverSrc,
      serverApiPic: Setting.serverApiPic,
      isShow: false,
      advert_id: 0,
      uploadList: [], // 缩咯图
      imgUrl: '',
      visible: false,
      item_list1: [],
      item_list2: [],
      item_list3: [],
      item_list4: [],
      type_str: '请选择',
      type_format:{
        1:'绘本',
        2:'导读',
        3:'活动',
        4:'文章',
      },
      advertInfos: {
        advert_id: 0,
        advert_name: '',
        pic_url: '',
        type: 0,
        url: '',
        sort: 0,
        status: 1,
        delpics: [], // 服务器待删除的照片
        item_id: 0,
        article_id: 0,
        article_name: '',
        adv_group_id: 0
      },
      ruleValidate: {
        advert_name: [
          { required: true, message: '请输入广告名称', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    editShow (val) {
      this.isShow = val
      this.advertInfos.advert_id = 0
      this.advertInfos.advert_name = ''
      this.advertInfos.pic_url = ''
      this.advertInfos.type = 0
      this.advertInfos.url = ''
      this.advertInfos.sort = 0
      this.advertInfos.status = 1
      this.advertInfos.item_id = 0
      this.advertInfos.delpics = []
      this.uploadList = []
      this.advertInfos.article_id = 0
      this.advertInfos.article_name = ''
      this.article_name = ''
    },
    id (val) {
      this.advert_id = val
      if (this.advert_id > 0) {
        this.advertInfo()
      }
    }
  },
  created () {
  },
  methods: {
    handle () {
      this.$emit('updateStatusModel', false)
    },
    handleOk (name) {
      if (this.uploadList.length <= 0) {
        this.$Message.error('广告图必填')
        return
      }
      this.advertInfos.pic_url = this.uploadList[0]['url']
      this.advertInfos.adv_group_id = this.adv_group_id

      if (this.advertInfos.type > 0 && this.advertInfos.type <4 ) {
        if(this.advertInfos.item_id<1){
          this.$Message.error(this.type_format[this.advertInfos.type]+'必选')
          return
        }
      }

      this.$refs[name].validate(valid => {
        if (valid) {
          addAdv(this.advertInfos).then(res => {
            let msg = '添加成功'
            if (this.advertInfos.advert_id > 0) {
              msg = '编辑成功'
            }
            if (res.code === 200) {
              this.$Message.success(msg)
              this.$emit('updateStatusModel', false)
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },
    advertInfo () {
      if (this.advert_id) {
        let data = { 'advert_id': this.advert_id }
        advertApi(data).then(res => {
          this.advertInfos = res.data
          this.advertInfos.delpics=[];
          this.article_name = this.advertInfos.article_name
          this.uploadList.push({ 'url': this.advertInfos.pic_url, 'showProgress': false, 'percentage': 100, 'status': 'finished' })
          this.type_change(this.advertInfos.type)
        }).catch(res => {
          this.$Message.error(res.msg)
        })
      }
    },
    selectChange (val) {
      console.log(val);
      if(!val){
        val='0'
      }
      console.log(val);
      this.advertInfos.item_id = val
    },
    type_change (val) {
      this.type_str=this.type_format[val]
      switch (val) {
        case 1:
          //拿绘本
          bookInfo().then(res => {
            this.item_list1=res.data
          }).catch(res => {
            this.$Message.error(res.msg)
          })
          break;
        case 2:
          //拿导读
          bookVideo().then(res => {
            this.item_list2=res.data
          }).catch(res => {
            this.$Message.error(res.msg)
          })
          break;
        case 3:
          //拿活动
          activityInfo().then(res => {
            this.item_list3=res.data
          }).catch(res => {
            this.$Message.error(res.msg)
          })
          break;
        case 4:
          //文章
          articleInfo().then(res => {
            this.item_list4=res.data
          }).catch(res => {
            this.$Message.error(res.msg)
          })
          break;
      }
    },
    handleView (url) {
      this.imgUrl = url
      this.visible = true
    },
    // 缩略图删除
    handleRemove (file) {
      const fileList2 = this.uploadList
      this.advertInfos.delpics.push(file.url)
      this.uploadList.splice(fileList2.indexOf(file), 1)
      this.uploadList = []
    },
    // 缩略图
    handleSuccess (res, file) {
      let file_url = res.data.file_url
      if (file_url.substring(0, 5) === 'https') {
        file.url = file_url
      } else {
        file.url = this.server_url + file_url
      }
      this.uploadList = this.$refs.uploadThumb.fileList
    },
    handleFormatError (file) {
      this.$Message.error('文件' + file.name + '格式错误，请上传jpg或者png')
    },
    handleMaxSize (file) {
      this.$Message.error('文件' + file.name + '太大，不能大于10M')
    },
    // 缩略图
    handleBeforeUpload () {
      const check = this.uploadList.length < 1
      if (!check) {
        this.$Message.error('只能上传1张图片')
      }
      return check
    },
    updateStatusModel (modalStatus) {
      this.selectShow = modalStatus
    },
    closeModal (val) {
      if (val) {
        this.confirm = false
        this.selectShow = false
      }
    }
  }
}
</script>
